import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Checkbox, Input, Typography } from 'antd';

import BaseLayout from '../../layout/base';
import BottomNavigator from '../BottomNavigator';
import TopNavigator from '../TopNavigator';
import Progress from '../Progress';
import { LAND_MAIN_USES } from '../../../constants';

const { Text } = Typography;

class MainUsesStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputotro: false,
      errors: {},
    };
  }

  handleOnNext = () => {
    if (
      Array.isArray(this.props.lands_main_uses) &&
      this.props.lands_main_uses.length > 0
    ) {
      this.props.next();
    } else {
      this.setState({
        errors: { lands_main_uses: 'Campo requerido' },
      });
    }
  };

  handleOnChange = checkedValue => {
    const { setFieldValue } = this.props;
    setFieldValue('lands_main_uses', checkedValue);

    if (checkedValue.indexOf('others') != -1) {
      this.setState({ inputotro: true });
    } else {
      this.setState({ inputotro: false });
    }
  };

  render() {
    const { errors } = this.state;
    return (
      <BaseLayout
        title="FORMULARIO DE PROPUESTA"
        onClose={this.props.onClose}
        footerXs={[14, 0, 10]}
        showCloseBtn={true}
        footerRightComponent={
          <Progress onNext={this.handleOnNext} step={9} steps={18} />
        }
      >
        <div className="main-content">
          <TopNavigator previous={this.props.previous} step={9} steps={18} />
          <Row gutter={30}>
            <Col
              md={12}
              style={{
                textAlign: 'center',
              }}
            >
              <h2>
                ¿Cuáles son los usos principales actuales de la propiedad?
              </h2>
              {errors.lands_main_uses && (
                <Text type="danger">{errors.lands_main_uses}</Text>
              )}
              <br />
              <p className="text-left text-muted">
                <strong>Agrícola</strong> – terrenos donde se cultiva la tierra y/o se cría ganado.
                <br />
                <strong>Área natural</strong> - área que cuenta con diversidad ecológica y/o valor cultural, científico o de paisaje.
                <br />
                <strong>Comercial</strong> - ocurre actividad económica en este lugar.
                <br />
                <strong>Industrial</strong> - existen estructuras dedicadas a la fabricación de productos; contiene maquinaria pesada.
                <br />
                <strong>Recreativo</strong> - espacio que permite actividades de entretenimiento como caminar, jugar, nadar, etc.
                <br />
                <strong>Residencial</strong> - presencia de viviendas, urbanizaciones, condominios, etc.
                <br />
                <strong>Turismo</strong> - presencia de hoteles o viviendas a corto plazo, recorridos, veredas autoguiadas y/u otras actividades relacionadas.
              </p>
              <br />
            </Col>
            <Col md={12}>
              <Checkbox.Group
                style={{ width: '100%' }}
                value={this.props.lands_main_uses}
                onChange={this.handleOnChange}
              >
                <Row>
                  {LAND_MAIN_USES.map(item => (
                    <Col key={item.value} span={24}>
                      <Checkbox
                        value={item.value}
                        className="inputprop radiobutton"
                      >
                        {item.label}
                      </Checkbox>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
              {this.state.inputotro && (
                <Input
                  name="lands_other_main_uses"
                  className="inputprop"
                  id="otro1"
                  size="large"
                  value={this.props.lands_other_main_uses}
                  onChange={this.props.handleChange}
                  maxLength="100"
                />
              )}
            </Col>
          </Row>
          <BottomNavigator
            onPrevious={this.props.previous}
            onNext={this.handleOnNext}
          />
        </div>
      </BaseLayout>
    );
  }
}

MainUsesStep.propTypes = {
  lands_main_uses: PropTypes.array,
  lands_other_main_uses: PropTypes.string,
  next: PropTypes.func,
  previous: PropTypes.func,
  handleChange: PropTypes.func,
  setFieldValue: PropTypes.func,
  onClose: PropTypes.func,
};

export default MainUsesStep;
